(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  var panel = overlay.querySelector('.search-overlay__panel');
  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-search-results]');
  var clearBtn = overlay.querySelector('[data-search-clear]');
  var root = document.documentElement;

  var MIN_CHARS = 2;
  var DEBOUNCE = 250;
  var debounceT = null;
  var controller = null;
  var lastTerm = null;
  var activeIndex = -1;
  var lastFocused = null;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function open() {
    lastFocused = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    root.style.overflow = 'hidden';
    // Defer focus so the open transition has begun (mobile keyboards behave better).
    setTimeout(function () { input.focus(); }, 70);
  }

  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    root.style.overflow = '';
    if (controller) { controller.abort(); controller = null; }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function clearQuery() {
    if (controller) { controller.abort(); controller = null; }
    clearTimeout(debounceT);
    lastTerm = null;
    input.value = '';
    results.innerHTML = '';
    clearBtn.hidden = true;
    overlay.classList.remove('is-searching', 'is-loading');
    resetActive();
  }

  /* ---- keyboard navigation over result options (combobox/listbox pattern) ---- */

  function options() {
    return results.querySelectorAll('[role="option"]');
  }

  function resetActive() {
    var opts = options();
    for (var i = 0; i < opts.length; i++) {
      opts[i].classList.remove('is-active');
      opts[i].setAttribute('aria-selected', 'false');
    }
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');
    input.setAttribute('aria-expanded', opts.length ? 'true' : 'false');
  }

  function setActive(idx) {
    var opts = options();
    if (!opts.length) return;
    if (idx < 0) idx = opts.length - 1;
    if (idx >= opts.length) idx = 0;
    for (var i = 0; i < opts.length; i++) {
      var on = i === idx;
      opts[i].classList.toggle('is-active', on);
      opts[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    activeIndex = idx;
    var el = opts[idx];
    input.setAttribute('aria-activedescendant', el.id);
    el.scrollIntoView({ block: 'nearest' });
  }

  function fetchResults(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    overlay.classList.add('is-loading');

    var url = routeRoot() + 'search/suggest'
      + '?q=' + encodeURIComponent(term)
      + '&resources[type]=product'
      + '&resources[limit]=8'
      + '&resources[options][unavailable_products]=last'
      + '&section_id=predictive-search';

    fetch(url, { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (text) {
        var section = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search');
        results.innerHTML = section ? section.innerHTML : '';
        // motion.js only observes .reveal nodes present at load — reveal injected cards now.
        var revealed = results.querySelectorAll('.reveal');
        for (var i = 0; i < revealed.length; i++) revealed[i].classList.add('is-in');
        overlay.classList.remove('is-loading');
        resetActive();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        overlay.classList.remove('is-loading');
        results.innerHTML = '';
        resetActive();
      });
  }

  function onInput() {
    var term = input.value.trim();
    clearBtn.hidden = term.length === 0;

    if (term.length < MIN_CHARS) {
      if (controller) { controller.abort(); controller = null; }
      clearTimeout(debounceT);
      lastTerm = null;
      results.innerHTML = '';
      overlay.classList.remove('is-searching', 'is-loading');
      resetActive();
      return;
    }

    overlay.classList.add('is-searching');
    if (term === lastTerm) return;
    lastTerm = term;
    clearTimeout(debounceT);
    debounceT = setTimeout(function () { fetchResults(term); }, DEBOUNCE);
  }

  function onInputKeydown(e) {
    var opts = options();
    switch (e.key) {
      case 'ArrowDown':
        if (!opts.length) return;
        e.preventDefault();
        overlay.classList.add('kbd-nav');
        setActive(activeIndex + 1);
        break;
      case 'ArrowUp':
        if (!opts.length) return;
        e.preventDefault();
        overlay.classList.add('kbd-nav');
        setActive(activeIndex - 1);
        break;
      case 'Enter':
        // With an option highlighted, open it; otherwise let the form submit to /search.
        if (activeIndex > -1 && opts[activeIndex]) {
          var link = opts[activeIndex].querySelector('a[href]');
          if (link) { e.preventDefault(); link.click(); }
        }
        break;
      case 'Escape':
        // Escape always closes the overlay, regardless of query/selection state.
        e.preventDefault();
        close();
        break;
    }
  }

  /* ---- focus trap: keep Tab order inside the dialog while it's open ---- */

  function focusables() {
    var nodes = panel.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
    var list = [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.hasAttribute('hidden') || n.disabled) continue;
      if (n.offsetParent === null && n !== document.activeElement) continue;
      list.push(n);
    }
    return list;
  }

  function trapTab(e) {
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  input.addEventListener('input', onInput);
  input.addEventListener('keydown', onInputKeydown);
  panel.addEventListener('keydown', trapTab);

  // Pointer hover over an option syncs the active descendant for consistent Enter behaviour.
  // Leaving keyboard mode hides the selection ring — the card's own hover dim is enough.
  results.addEventListener('mousemove', function (e) {
    var opt = e.target.closest('[role="option"]');
    if (!opt) return;
    overlay.classList.remove('kbd-nav');
    var opts = options();
    for (var i = 0; i < opts.length; i++) {
      if (opts[i] === opt && i !== activeIndex) { setActive(i); break; }
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) { close(); return; }
    if (e.target.closest('[data-search-clear]')) { clearQuery(); input.focus(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open') && document.activeElement !== input) close();
  });
})();
